import { API } from "../auth/authApi";

API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

// CREATE
export const createHelpSosApi = (data) => API.post("/help-sos", data);

// GET
export const getHelpSosApi = (params) =>
  API.get("/help-sos", { params });

// UPDATE
export const updateHelpSosApi = (id, data) =>
  API.put(`/help-sos/${id}`, data);

// DELETE
export const deleteHelpSosApi = (id) =>
  API.delete(`/help-sos/${id}`);

// ADD USERS
export const addUsersApi = (id, data) =>
  API.put(`/help-sos/${id}/add-user`, data);

// REMOVE USERS
export const removeUsersApi = (id, data) =>
  API.delete(`/help-sos/${id}/remove-user`, { data });